import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { resolveScreenLinks } from "../../utils/permissionScreens";

/**
 * 권한 키를 쓰는 실제 어드민 화면 링크 칩. 처음엔 max 개만 보이고 나머지는 "외 N개"로 접어 둔다(펼치기/접기).
 * 링크로 열 수 없는 화면(:param 이고 상위 라우트도 없음)은 클릭 안 되는 칩. screens 가 없거나 비면 아무것도 그리지 않는다.
 */
function PermissionScreenLinks({ screens, max = 3, label }) {
  const links = useMemo(() => resolveScreenLinks(screens), [screens]);
  const [expanded, setExpanded] = useState(false);
  if (links.length === 0) return null;

  const shown = expanded ? links : links.slice(0, max);
  const rest = links.length - shown.length;
  const titleOf = (link) => {
    const via = link.sources.filter((s) => s !== link.to);
    return via.length > 0 ? `${link.label} (${via.join(", ")} 진입 화면)` : link.to ?? link.label;
  };

  return (
    <div className="access-screen-links" data-testid="screen-links">
      {label && <span className="access-muted">{label}</span>}
      {shown.map((link) =>
        link.to ? (
          <Link key={`to:${link.to}`} to={link.to} className="access-chip access-chip-link" title={titleOf(link)}>
            {link.label}
          </Link>
        ) : (
          <span key={`text:${link.label}`} className="access-chip access-chip-plain" title="바로 열 수 없는 화면">
            {link.label}
          </span>
        ),
      )}
      {rest > 0 && (
        <button type="button" className="access-link access-more" aria-expanded={false} onClick={() => setExpanded(true)}>
          외 {rest}개
        </button>
      )}
      {expanded && links.length > max && (
        <button type="button" className="access-link access-more" aria-expanded onClick={() => setExpanded(false)}>
          접기
        </button>
      )}
    </div>
  );
}

export default PermissionScreenLinks;
